import { render, staticRenderFns } from "./GameCarShop.vue?vue&type=template&id=5960f34e&scoped=true&"
import script from "./GameCarShop.vue?vue&type=script&lang=js&"
export * from "./GameCarShop.vue?vue&type=script&lang=js&"
import style0 from "./GameCarShop.vue?vue&type=style&index=0&id=5960f34e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5960f34e",
  null
  
)

export default component.exports